<div class="container finance-summary">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 have-finance">
            <div class="have-f-c">
              <div class="lead-id">
                <p>Lead ID <span>{{ response?.reqId | uppercase }}</span></p>
              </div>
              <div class="msg">
                <div class="approve-con" *ngIf="transactionSuccess">
                  <div class="approve-icon">
                    <!-- <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z"
                        fill="url(#paint0_linear_328_31167)" />
                      <path
                        d="M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z"
                        fill="white" />
                      <path
                        d="M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z"
                        fill="#00A925" />
                      <path d="M64.5 77.5L72 85L85.5 71.5" stroke="white" stroke-width="4" />
                      <path
                        d="M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z"
                        fill="#D6F9DE" />
                      <path
                        d="M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z"
                        fill="#D6F9DE" />
                      <defs>
                        <linearGradient id="paint0_linear_328_31167" x1="75" y1="0" x2="75" y2="150"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E3FAE8" />
                          <stop offset="0.783744" stop-color="#DCFEE3" />
                          <stop offset="1" stop-color="#DAFFE2" />
                        </linearGradient>
                      </defs>
                    </svg> -->
                    <img [src]="environment1 + 'images/new-images/sucess.svg'" alt="sucess" loading="lazy">
                  </div>
                  <div class="approve-content">
                    <div class="row">
                      <div class="col-12">
                        <h3>Congratulations</h3>
                        <!-- <p>You have successfully booked {{ response?.leadInfo?.lead_info.model }}. We will be contacting
                          you shortly to confirm the details of your purchase.</p> -->
                          <p>Tata Motors Authorized Dealership  {{Dealername}}  has successfully received your booking.
                            Dealership will contact you shortly.</p>
                      </div>
                    </div>
                  </div>
                  <div class="row grid-box mb-4">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <p>Dealership Contact</p>
                      <div class="contact-box">
                        <p>{{response?.leadInfo?.dealer_name}}</p>
                        <div class="contact-number">
                          <div class="icon">
                            <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_328_31206)">
                                <path
                                  d="M7.805 8.90167C8.58695 10.2754 9.7246 11.4131 11.0983 12.195L11.835 11.1633C11.9535 10.9974 12.1286 10.8807 12.3273 10.8353C12.526 10.7898 12.7345 10.8188 12.9133 10.9167C14.0919 11.5608 15.3935 11.9481 16.7325 12.0533C16.9415 12.0699 17.1365 12.1646 17.2788 12.3186C17.421 12.4726 17.5 12.6745 17.5 12.8842V16.6025C17.5 16.8088 17.4235 17.0078 17.2853 17.161C17.1471 17.3142 16.9569 17.4106 16.7517 17.4317C16.31 17.4775 15.865 17.5 15.4167 17.5C8.28333 17.5 2.5 11.7167 2.5 4.58333C2.5 4.135 2.5225 3.69 2.56833 3.24833C2.58938 3.04308 2.68582 2.85293 2.83899 2.71469C2.99216 2.57646 3.19117 2.49996 3.3975 2.5H7.11583C7.32547 2.49997 7.52741 2.57896 7.6814 2.72121C7.83539 2.86346 7.93011 3.05852 7.94667 3.2675C8.05185 4.60649 8.43923 5.90807 9.08333 7.08667C9.18122 7.26547 9.21018 7.47395 9.16472 7.67266C9.11927 7.87137 9.00255 8.04654 8.83667 8.165L7.805 8.90167ZM5.70333 8.35417L7.28667 7.22333C6.83732 6.25341 6.52946 5.22403 6.3725 4.16667H4.175C4.17 4.305 4.1675 4.44417 4.1675 4.58333C4.16667 10.7967 9.20333 15.8333 15.4167 15.8333C15.5558 15.8333 15.695 15.8308 15.8333 15.825V13.6275C14.776 13.4705 13.7466 13.1627 12.7767 12.7133L11.6458 14.2967C11.1906 14.1198 10.7483 13.9109 10.3225 13.6717L10.2742 13.6442C8.63965 12.7139 7.28607 11.3604 6.35583 9.72583L6.32833 9.6775C6.08909 9.25166 5.88024 8.80945 5.70333 8.35417Z"
                                  fill="#0A0A5F" />
                              </g>
                              <defs>
                                <clipPath id="clip0_328_31206">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg> -->
                            <img [src]="environment1 + 'images/new-images/phone.svg'" alt="phone" loading="lazy">
                          </div>
                          <p class="numb">{{response?.leadInfo?.dealer_number}}</p>
                        </div>
                      </div>
                      <ng-container *ngIf="response?.leadInfo?.vas_info?.vas_payble_amount">
                        <button type="button" class="btn btn-primary btn-grad-primary btn-track w-100 mt-2"
                        (click)="gotoBooking()"
                        data-toggle="tooltip" data-placement="top" title="Click here to Track your request"
                        >Track your request</button>
                      </ng-container>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 "
                      [ngClass]="response?.leadInfo?.vas_info?.vas_payble_amount ?
                                              bookingData?.payment_info?.type_of_pay_gate == 'CCAVENUE'  ? 'd-none' : 'd-none' : 'd-none'">
                      <p class="mobile-top-margin">Payment Details</p>
                      <div class="payment-box">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-2">
                              <div class="card1">
                                <ul id="progressbar" class="text-center">
                                  <li class="active step0">
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20"
                                      height="20" viewBox="0 0 20 20" fill="none">
                                      <g clip-path="url(#clip0_7349_31063)">
                                        <path
                                          d="M8.33312 12.6433L15.9931 4.9825L17.1723 6.16083L8.33312 15L3.02979 9.69666L4.20812 8.51833L8.33312 12.6433Z"
                                          fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_7349_31063">
                                          <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg> -->
                                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                  </li>
                                  <li class="active1 step0" *ngIf="!vasPaymentSuccess"></li>
                                  <li class="active step0" *ngIf="vasPaymentSuccess"></li>
                                </ul>
                              </div>
                            </div>
                            <div class="col-sm-10 mobile-margin-l">
                              <div class="row">
                                <div class="col-12"
                                  [ngClass]="((response?.leadInfo?.lead_info?.payment_status != 'Payment Confirmed') &&
                                                              (response?.leadInfo?.lead_info?.opty_status == 'C1 (Quote Tendered)' ||
                                                              response?.leadInfo?.lead_info?.opty_status == 'C1A (Papers submitted)' ||
                                                              response?.leadInfo?.lead_info?.opty_status == 'PENDING')) ?
                                                              (response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed')? 'disabled' : '' : 'disabled' ">
                                  <span class="d-flex">
                                    <h5 class="subtitle">Booking Amount</h5>
                                    <h5 class="pricetxt"> {{ (response?.leadInfo?.lead_info?.booking_amount *
                                      response?.leadInfo?.lead_info?.quantity) | currency:'INR':'symbol':'4.0-0' }}</h5>
                                  </span>
                                </div>
                                <div class="12">
                                  <h6 class="detailtxt" >
                                    {{ this.bookingData?.payment_data[0]?.status == 'captured' ?
                                    'Transaction Id: '+this.bookingData?.payment_data[0]?.razorpay_payment_id :'This is the amount that you need to pay to book the vehicle.'
                                    }}
                                  </h6>
                                  <button class="paynowbtnpaid disabled">Paid
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg"
                                      width="18" height="18" viewBox="0 0 18 18" fill="none">
                                      <g clip-path="url(#clip0_7441_523)">
                                        <path
                                          d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z"
                                          fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_7441_523">
                                          <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg> -->
                                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                  </button>
                                </div>
                              </div>
                              <div class="row margintop">
                                <div class="col-12"
                                  [ngClass]="((response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed') && response?.leadInfo?.vas_info?.length > 0) ? '' : 'disabled' ">
                                  <span class="d-flex">
                                    <h5 class="subtitle">VAS Booking Amount
                                    </h5>
                                    <h5 class="pricetxt"> {{response?.leadInfo?.vas_info?.vas_payble_amount |
                                      currency:'INR':'symbol':'4.0-0'}}</h5>
                                  </span>
                                </div>
                                <div class="12" >
                                  <h6 class="detailtxt">{{  this.bookingData?.payment_data[1]?.status == 'captured' ? 'Transaction Id: '+ this.bookingData?.payment_data[1]?.razorpay_payment_id :'This is the amount that you need to pay to for buying the VAS.'
                                  }}
                                  </h6>
                                  <button *ngIf="!vasPaymentSuccess"  [ngClass]="
                                  this.bookingData?.payment_data[0]?.status !== 'captured' ? 'disabled':'' " class="paynowbtn" (click)="payVAS(response)"
                                   data-toggle="tooltip" data-placement="top" title="Click here to Proceed for Payment">Pay Now</button>
                                                                   <button *ngIf="vasPaymentSuccess" class="paynowbtnpaid disabled">Paid
                                                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                    <g clip-path="url(#clip0_7441_523)">
                                                                      <path d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z" fill="white"/>
                                                                    </g>
                                                                    <defs>
                                                                      <clipPath id="clip0_7441_523">
                                                                        <rect width="18" height="18" fill="white"/>
                                                                      </clipPath>
                                                                    </defs>
                                                                  </svg> -->
                                                                  <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                                                </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="!response?.leadInfo?.vas_info?.vas_payble_amount">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <button type="button" class="btn btn-primary btn-grad-primary btn-track w-100 track-mtop"
                        data-toggle="tooltip" data-placement="top" title="Click here to Track your request"
                          (click)="gotoBooking()">Track your request</button>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="reject-con" *ngIf="transactionfailed">
                  <div class="reject-icon">
                    <!-- <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z"
                        fill="url(#paint0_linear_328_31175)" />
                      <path
                        d="M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z"
                        fill="white" />
                      <path
                        d="M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z"
                        fill="#A91400" />
                      <path
                        d="M83.4853 89.3139L75 80.8286L66.5147 89.3139L63.6863 86.4854L72.1716 78.0002L63.6863 69.5149L66.5147 66.6865L75 75.1717L83.4853 66.6865L86.3137 69.5149L77.8284 78.0002L86.3137 86.4854L83.4853 89.3139Z"
                        fill="white" />
                      <path
                        d="M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z"
                        fill="#F9DAD6" />
                      <path
                        d="M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z"
                        fill="#F9DAD6" />
                      <defs>
                        <linearGradient id="paint0_linear_328_31175" x1="75" y1="0" x2="75" y2="150"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FAE6E3" />
                          <stop offset="0.783744" stop-color="#FEE0DC" />
                          <stop offset="1" stop-color="#FFDEDA" />
                        </linearGradient>
                      </defs>
                    </svg> -->
                    <img [src]="environment1 + 'images/new-images/error.svg'" alt="error" loading="lazy">
                  </div>
                  <div class="reject-content">
                    <h3>Transaction Failed</h3>
                    <p>Your payment of {{getTotalAmount(response) | currency:'INR':'symbol':'4.0-0' }}/- is not
                      received. Any amount deducted will be refunded in 3-5 days. Try again with different payment
                      method</p>
                  </div>
                  <div class="row cta-action mb-5">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-4">
                      <button type="button"
                        class="btn social-login btn-outline-primary btn-grad-outline-primary btn-track w-100 mt-5"
                        (click)="gotoBooking()"
                        data-toggle="tooltip" data-placement="top" title="Click here to Track your status request"
                        > Track your status request</button>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 "
                      [ngClass]="response?.leadInfo?.vas_info?.vas_payble_amount ?
                                               bookingData?.payment_info?.type_of_pay_gate == 'CCAVENUE' ? 'd-none' : 'd-none' : 'd-none'">
                      <p class="mobile-top-margin">Payment Details</p>
                      <div class="payment-box">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-2">
                              <div class="card1">
                                <ul id="progressbar" class="text-center">
                                  <li class="active step0"
                                    *ngIf="response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed'">
                                    <!-- <svg
                                      xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                      fill="none">
                                      <g clip-path="url(#clip0_7349_31063)">
                                        <path
                                          d="M8.33312 12.6433L15.9931 4.9825L17.1723 6.16083L8.33312 15L3.02979 9.69666L4.20812 8.51833L8.33312 12.6433Z"
                                          fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_7349_31063">
                                          <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg> -->
                                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                  </li>

                                  <li class="active0 step0"
                                    *ngIf="response?.leadInfo?.lead_info?.payment_status !== 'Payment Confirmed'"></li>
                                  <li class="active1 step0"></li>
                                </ul>
                              </div>
                            </div>
                            <div class="col-sm-10 mobile-margin-l">
                              <div class="row">

                                <div class="col-12">
                                  <span class="d-flex">
                                    <h5 class="subtitle">Booking Amount</h5>
                                    <h5 class="pricetxt"> {{ (response?.leadInfo?.lead_info?.booking_amount *
                                      response?.leadInfo?.lead_info?.quantity) | currency:'INR':'symbol':'4.0-0' }}</h5>
                                  </span>
                                </div>
                                <div class="12">
                                  <h6 class="detailtxt">{{ this.bookingData?.payment_data[0]?.status == 'captured' ? 'Transaction Id: '+this.bookingData?.payment_data[0]?.razorpay_payment_id :'This is the amount that you need to pay to book the vehicle.'
                                  }}
                                  </h6>

                                  <button class="paynowbtn "
                                    *ngIf="((response?.leadInfo?.lead_info?.payment_status != 'Payment Confirmed'))"
                                    [ngClass]="((response?.leadInfo?.lead_info?.payment_status != 'Payment Confirmed') &&
                                                                (response?.leadInfo?.lead_info?.opty_status == 'C1 (Quote Tendered)' ||
                                                                response?.leadInfo?.lead_info?.opty_status == 'C1A (Papers submitted)' ||
                                                                response?.leadInfo?.lead_info?.opty_status == 'PENDING')) ?
                                                                (response?.leadInfo?.vas_info?.payment_status == 'Payment Confirmed')? 'disabled' : '' : '' "
                                    (click)="payBookingAmt()"
                                    data-toggle="tooltip" data-placement="top" title="Click here to Proceed for Payment"
                                    >Pay Now
                                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                      height="18" viewBox="0 0 18 18" fill="none">
                                      <g clip-path="url(#clip0_7441_523)">
                                        <path
                                          d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z"
                                          fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_7441_523">
                                          <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg> -->
                                  </button>

                                  <button *ngIf="response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed'"
                                  data-toggle="tooltip" data-placement="top" title="Payment Confirmed"
                                    class="paynowbtnpaid disabled">Paid
                                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18"
                                      height="18" viewBox="0 0 18 18" fill="none">
                                      <g clip-path="url(#clip0_7441_523)">
                                        <path
                                          d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z"
                                          fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_7441_523">
                                          <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg> -->
                                  </button>
                                </div>
                              </div>
                              <div class="row margintop">
                                <div class="col-12">
                                  <span class="d-flex">
                                    <h5 class="subtitle">VAS Booking Amount</h5>
                                    <h5 class="pricetxt"> {{response?.leadInfo?.vas_info?.vas_payble_amount |
                                      currency:'INR':'symbol':'4.0-0'}}</h5>
                                  </span>
                                </div>
                                <div class="12">
                                  <h6 class="detailtxt">This is the amount that you need to pay to for buying the VAS.
                                  </h6>
                                  <button class="paynowbtn " [ngClass]="((response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed')
                                                                           && (response?.leadInfo?.vas_info?.payment_status !== 'initialized')
                                                                          && (response?.leadInfo?.vas_info?.payment_status !== 'Payment Confirmed')) ? '' :
                                                                          ((bookingData?.payment_status == 'Payment Confirmed')
                                                                          && (bookingData?.leadInfo?.vas_data[0]?.payment_status !== 'Payment Confirmed')) ? '' :
                                                                    'disabled' " (click)="payVAS(response)"
                                                                    data-toggle="tooltip" data-placement="top" title="Click here to Proceed for Payment"
                                                                    >Pay Now</button>
                                                                </div>
                                                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 product-info">
        <div class="order-summary">
          <img alt=""
            [src]="bookingImage ? bookingImage  : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/default/tata_trucks.jpg' "
            loading="lazy" />
        </div>
        <div class="product-details">
          <div class="name-status">
            {{ response?.leadInfo?.lead_info.model }}
          </div>
          <div class="product-booking-amount divider">
            <div class="booking-amount">
              Booking Amount
              <span>{{ response?.leadInfo?.lead_info?.booking_amount | currency:'INR':'symbol':'4.0-0' }} </span>
            </div>
            <div class="product-quantity">
              Quantity <span>{{response?.leadInfo?.lead_info.quantity}}</span>
            </div>
            <div class="product-quantity" *ngIf="response?.leadInfo?.vas_info">
              VAS Booking Amount <span>{{response?.leadInfo?.vas_info?.vas_payble_amount |
                currency:'INR':'symbol':'4.0-0'}}</span>
            </div>

          </div>
          <div class="booking-amount">
            Total Booking Amount <span>{{getTotalAmount1(response) | currency:'INR':'symbol':'4.0-0'}}</span>
          </div>

        </div>
      </div>
    </div>

  </div>
 <ng-template #content let-modal>
      <div class="modal-header modal-title">
        <h5 class="titletext">Payment Details</h5>
      <button type="button" (click)="modal.dismiss('Cross click')" class="btn-close mb-10"></button>

      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="payment-box">
            <div class="col-md-2">
              <div class="card1">
                <ul id="progressbar2" class="text-center">

                  <li class="active0 step0"
                  *ngIf="bookingData?.payment_data[0]?.status !== 'captured' "
                  ></li>
                  <li class="active step0"
                    *ngIf="bookingData?.payment_data[0]?.status == 'captured' "
                    ></li>

                    <li class="active1 step0" *ngIf="bookingData?.payment_data[1]?.status !='captured' "></li>

                  </ul>
              </div>
            </div>
            <div class="col-md-10 mobile-margin-l">
              <div class="row">

                <div class="col-12">
                  <span class="d-flex">
                    <h5 class="subtitle">Booking Amount</h5>
                    <h5 class="pricetxt"> {{ (response?.leadInfo?.lead_info?.booking_amount *
                      response?.leadInfo?.lead_info?.quantity) | currency:'INR':'symbol':'4.0-0' }}</h5>
                  </span>
                </div>
                <div class="12">
                  <h6 class="detailtxt">{{ this.bookingData?.payment_data[0]?.status == 'captured' ?'Transaction Id: '+ this.bookingData?.payment_data[0]?.razorpay_payment_id :'This is the amount that you need to pay to book the vehicle.'
                  }}                   .
                  </h6>
                  <button class="paynowbtn "
                    *ngIf="((response?.leadInfo?.lead_info?.payment_status != 'Payment Confirmed' && bookingData?.payment_status != 'Payment Confirmed'))"
                    [ngClass]="((response?.leadInfo?.lead_info?.payment_status != 'Payment Confirmed') &&
                                              (response?.leadInfo?.lead_info?.opty_status == 'C1 (Quote Tendered)' ||
                                              response?.leadInfo?.lead_info?.opty_status == 'C1A (Papers submitted)' ||
                                              response?.leadInfo?.lead_info?.opty_status == 'PENDING')) ?
                                              (response?.leadInfo?.vas_info?.payment_status == 'Payment Confirmed')? 'disabled' : '' : '' "
                    (click)="payBookingAmt()"
                    data-toggle="tooltip" data-placement="top" title="Click here to Proceed for Payment"
                    >Pay Now
                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 18 18" fill="none">
                      <g clip-path="url(#clip0_7441_523)">
                        <path
                          d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z"
                          fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_7441_523">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> -->
                  </button>

                  <button
                    *ngIf="response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed' || bookingData?.payment_status == 'Payment Confirmed'"
                    class="paynowbtnpaid disabled"
                    data-toggle="tooltip" data-placement="top" title="Payment Confirmed"
                    >Paid
                    <img [src]="environment1 + 'images/new-images/tick.svg'" alt="tick" loading="lazy">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 18 18" fill="none">
                      <g clip-path="url(#clip0_7441_523)">
                        <path
                          d="M7.50005 11.379L14.3941 4.48425L15.4553 5.54475L7.50005 13.5L2.72705 8.727L3.78755 7.6665L7.50005 11.379Z"
                          fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_7441_523">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> -->
                  </button>

                </div>
              </div>
              <div class="row margintop">
                <div class="col-12">
                  <span class="d-flex">
                    <h5 class="subtitle">VAS Booking Amount</h5>
                    <h5 class="pricetxt"> {{response?.leadInfo?.vas_info?.vas_payble_amount |
                      currency:'INR':'symbol':'4.0-0'}}</h5>
                  </span>
                </div>
                <div class="12">
                  <h6 class="detailtxt">
                    {{ this.bookingData?.payment_data[1]?.status == 'captured' ? 'Transaction Id: '+this.bookingData?.payment_data[1]?.razorpay_payment_id :'This is the amount that you need to pay to for buying the VAS.'
                  }}
                  </h6>
                  <button *ngIf="!vasPaymentSuccess" [ngClass]="
                  this.bookingData?.payment_data[0]?.status !== 'captured' ? 'disabled':'' " class="paynowbtn" (click)="payVAS(response)"
                   data-toggle="tooltip" data-placement="top" title="Click here to Proceed for Payment">Pay
                    Now</button>

                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
      </div>
    </ng-template>
</div>
